var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$bp.isMdOrLess && _vm.isTimelineOpen)?_c('div',{staticClass:"timeline-images hide-scrollbar",class:{'square-mode': !_vm.isMosaicModeActive}},_vm._l((_vm.images),function(image){return _c('item-gallery-list-item',{key:image.id,attrs:{"image":image}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }